/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/executor/components/ResumeWorkCard.jsx
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Executor Workspace
 *
 * DESCRIPTION:
 * Displays the last work executed by the logged-in executor
 * so that execution can continue with a single click.
 *
 ******************************************************************************/

import React from "react";
//import { useNavigate } from "react-router-dom";

export default function ResumeWorkCard({

    work,
    onExecute,

}) {

    //const navigate = useNavigate();

    if (!work) {

        return (

            <div className="card shadow-sm h-100">

                <div className="card-body text-center text-muted py-5">

                    <i className="fas fa-inbox fa-2x mb-3" />

                    <h6>No Work To Resume</h6>

                    <small>

                        You have no work currently in progress.

                    </small>

                </div>

            </div>

        );

    }

    return (

        <div className="card shadow-sm border-0 h-100">

            <div
                className="card-header text-white"
                style={{

                    background:
                        "linear-gradient(90deg,#0d6efd,#4f8cff)"

                }}
            >

                <div className="fw-bold">

                    Resume Work

                </div>

                <small>

                    Continue from where you stopped

                </small>

            </div>

            <div className="card-body">

                <div className="mb-3">

                    <small className="text-muted">

                        Work Number

                    </small>

                    <div className="fw-bold">

                        {work.work_no}

                    </div>

                </div>

                <div className="mb-3">

                    <small className="text-muted">

                        Title

                    </small>

                    <div>

                        {work.title}

                    </div>

                </div>

                <div className="row mb-3">

                    <div className="col-6">

                        <small className="text-muted">

                            Priority

                        </small>

                        <div>

                            {work.priority}

                        </div>

                    </div>

                    <div className="col-6">

                        <small className="text-muted">

                            Status

                        </small>

                        <div>

                            {work.status}

                        </div>

                    </div>

                </div>

                <div className="mb-3">

                    <small className="text-muted">

                        Progress

                    </small>

                    <div className="progress">

                        <div
                            className="progress-bar bg-success"
                            style={{

                                width:
                                    `${work.progress}%`

                            }}
                        >

                            {work.progress}%

                        </div>

                    </div>

                </div>

                <div className="row">

                    <div className="col-6">

                        <small className="text-muted">

                            Due Date

                        </small>

                        <div>

                            {work.due_date}

                        </div>

                    </div>

                    <div className="col-6">

                        <small className="text-muted">

                            Last Updated

                        </small>

                        <div>

                            {work.updated_at}

                        </div>

                    </div>

                </div>

            </div>

            <div className="card-footer bg-white text-end">

                <button

                    className="btn btn-primary"

                    onClick={() =>

                        onExecute?.(work.id)

                    }

                >

                    <i className="fas fa-play me-2" />

                    Continue

                </button>

            </div>

        </div>

    );

}